import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/types';
import TooltipTrigger from './TooltipTrigger';
import TooltipHeader from './TooltipHeader';
import TooltipRow from './TooltipRow';
import TooltipSection from './TooltipSection';
import TooltipCustomItem from './TooltipCustomItem';
import './styles.scss';

export interface ToolingCoverageTooltipProps {
  children: React.ReactNode;
  id?: string;
  placement?: Placement;
  /** Dev helper: forces the tooltip open regardless of hover. Useful for inspecting styles in the browser. */
  forceOpen?: boolean;
}

const isTrigger = (child: React.ReactNode): child is React.ReactElement =>
  React.isValidElement(child) &&
  (child.type as React.FC).displayName === 'ToolingCoverageTooltip.Trigger';

const ToolingCoverageTooltipRoot = ({
  children,
  id = 'tooltip',
  placement = 'top',
  forceOpen,
}: ToolingCoverageTooltipProps) => {
  const childArray = React.Children.toArray(children);
  const triggerChild = childArray.find(isTrigger) as React.ReactElement | undefined;
  const bodyChildren = childArray.filter((child) => !isTrigger(child));

  return (
    <OverlayTrigger
      placement={placement}
      show={forceOpen}
      overlay={
        <Tooltip
          id={id}
          className="tooling-tooltip text-text-black d-flex justify-content-center align-items-center"
        >
          <div className="tooling-tooltip__body">{bodyChildren}</div>
        </Tooltip>
      }
    >
      <div className="tooling-tooltip__content d-flex justify-content-center align-items-center">
        {triggerChild?.props.children ?? null}
      </div>
    </OverlayTrigger>
  );
};

ToolingCoverageTooltipRoot.Trigger = TooltipTrigger;
ToolingCoverageTooltipRoot.Header = TooltipHeader;
ToolingCoverageTooltipRoot.Row = TooltipRow;
ToolingCoverageTooltipRoot.Section = TooltipSection;
ToolingCoverageTooltipRoot.CustomItem = TooltipCustomItem;

export const ToolingCoverageTooltip = ToolingCoverageTooltipRoot;
export default ToolingCoverageTooltipRoot;
